import { colors } from "@mui/material";

import SettingsIcon from '@mui/icons-material/Settings';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

export const finalSteps = [
    {
        color: colors.lightBlue[500],
        title: 'Technical Setup',
        description: 'We configure inventory management, connect to ONDC-approved logistics providers, and integrate secure payment gateways - all without requiring technical work from your side.',
        icon: (<SettingsIcon />),
    },
    {
        color: colors.lightBlue[500],
        title: 'Testing & Launch',
        description: 'Before going live, we conduct thorough testing with internal orders to verify all systems are working perfectly. Once verified, your products appear across all ONDC buyer apps.',
        icon: (<CheckCircleOutlineIcon />),
    },
    {
        color: colors.lightBlue[500],
        title: 'Growth & Optimisation',
        description: 'Access our dashboard to monitor orders, manage returns, and analyse performance. Our team provides ongoing support to help you maximise sales and customer satisfaction.',
        icon: (<TrendingUpIcon />),
    }
];

export default finalSteps;